import { ColorConstants } from '@shared/constants';
import {
    Box, makeStyles, styled as styledMaterial,
} from '@material-ui/core';
import { Button } from '@paretogroup/tess';

export const SplashScreenWrapper = styledMaterial(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    '& > *': {
        margin: '10px',
    },
});


export const MessageWrapper = styledMaterial(Box)({
    fontFamily: 'Helvetica',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '18px',
    textAlign: 'center',
    color: ColorConstants.white,
});

export const SignOutHeaderButton = styledMaterial(Button)({
    width: '92px',
    height: '32px',
    backgroundColor: ColorConstants.white,
    WebkitTextFillColor: ColorConstants.black,
    fontSize: '14px',
    '&:hover': {
        backgroundColor: ColorConstants['white-lilac'],
        opacity: 0.9,
    },
});


export const useStyles = makeStyles(() => ({
    title: {
        margin: '0px',
    },
    subtitle: {
        margin: '0px',
    },
    elementsContainer: {
        width: '450px',
        marginBottom: '180px',
    },
}));

export const backgroundGradient = 'linear-gradient(130.58deg, #8DD7D2 33.08%, #8D90D9 66.88%);';
